module.exports = __webpack_public_path__ + "05615112706e0396ff8c91eb9b6c05f2.svg";